import request from '../request';
import { productAccessAPI } from './urls';

// User Story 4: Product Access and Visibility Service

/**
 * US 4.3: Get active products for a customer (school or trust) based on subscription status
 * Only returns products if subscription is Active or in Grace Period
 */
const GetActiveProducts = (schoolId = null, matId = null) => {
  return request({
    url: productAccessAPI.GetActiveProducts(schoolId, matId),
    method: 'GET',
  })
    .then((response) => response)
    .catch((error) => error);
};

/**
 * US 4.4: Get subscription status including grace period
 * Returns: "Active", "Grace Period", "Expired", "Cancelled", "Archived"
 */
const GetSubscriptionStatus = (subscriptionId) => {
  return request({
    url: productAccessAPI.GetSubscriptionStatus(subscriptionId),
    method: 'GET',
  })
    .then((response) => response)
    .catch((error) => error);
};

/**
 * US 4.4: Check if customer is in grace period
 */
const IsInGracePeriod = (schoolId = null, matId = null) => {
  return request({
    url: productAccessAPI.IsInGracePeriod(schoolId, matId),
    method: 'GET',
  })
    .then((response) => response)
    .catch((error) => error);
};

const productAccessService = {
  GetActiveProducts,
  GetSubscriptionStatus,
  IsInGracePeriod,
};

export default productAccessService;
